__turbopack_context__.v({
  "className": "cardinalclassicfont_5dd70bfa-module__cEIjCq__className",
  "variable": "cardinalclassicfont_5dd70bfa-module__cEIjCq__variable",
});
